import mapKeys from 'lodash/mapKeys'

export class KeyRemapper {
  constructor(private readonly map: Record<string, string>) {}

  remap(data: any) {
    return mapKeys(data, (_, key) => this.map[key] ?? key)
  }

  unremap(data: any) {
    const inverseMap = Object.fromEntries(Object.entries(this.map).map(([key, value]) => [value, key]))
    Object.keys(this.map).forEach(key => Reflect.deleteProperty(data, key))
    return mapKeys(data, (_, key) => inverseMap[key] ?? key)
  }
}
